module.exports = __webpack_public_path__ + "static/things_take_time-840c9b54b6841305edd75fd71fc5a664.png";